import React, { useState, useEffect } from "react";
import ApplicationLayout from "../../layouts/ApplicationLayout";
import CommonExpenseAddForm from "./CommonExpenseAddForm";

const ExpenseAdd = (props) => {

  return (
    <ApplicationLayout>
     <CommonExpenseAddForm history={props.history} match={props.match} location={props.location} />
    </ApplicationLayout>
  );
};

export default ExpenseAdd;